/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 商机
 */
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
import { AjaxBasics } from "../../helpers";
export class BusinessController<T = any> extends BasesController<T> {
    constructor() {
        super({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.usersvr_business_list,
            paginationParams: {
                currentKey: 'curPageNo',
                pageSizeKey: 'pageSize',
                filterKey: 'search',
                response: {
                    dataSource: 'recordList',
                    total: 'recordCount'
                }
            }
        })
    }

    /**
     * 商机记录提交 
     * @returns 
     */
    submitBusiness(body) {
        return AjaxBasics.request({ ...EnumAPI.usersvr_submitbusiness, body })
    }

}